// Localization configuration by country
const LOCALIZATION_CONFIG = {
  AU: {
    country: 'AU',
    countryName: 'Australia',
    dateFormat: 'dd/mm/yyyy',
    currencySymbol: '$',
    currencyCode: 'AUD',
    timezone: 'Australia/Sydney',
    locale: 'en-AU'
  },
  UK: {
    country: 'UK',
    countryName: 'United Kingdom',
    dateFormat: 'dd/mm/yyyy',
    currencySymbol: '£',
    currencyCode: 'GBP',
    timezone: 'Europe/London',
    locale: 'en-GB'
  },
  US: {
    country: 'US',
    countryName: 'United States',
    dateFormat: 'mm/dd/yyyy',
    currencySymbol: '$',
    currencyCode: 'USD',
    timezone: 'America/New_York',
    locale: 'en-US'
  },
  CA: {
    country: 'CA',
    countryName: 'Canada',
    dateFormat: 'dd/mm/yyyy',
    currencySymbol: '$',
    currencyCode: 'CAD',
    timezone: 'America/Toronto',
    locale: 'en-CA'
  },
  NZ: {
    country: 'NZ',
    countryName: 'New Zealand',
    dateFormat: 'dd/mm/yyyy',
    currencySymbol: '$',
    currencyCode: 'NZ$',
    timezone: 'Pacific/Auckland',
    locale: 'en-NZ'
  }
};

// Get localization config for a country
export const getLocalizationConfig = (country = 'AU') => {
  return LOCALIZATION_CONFIG[country] || LOCALIZATION_CONFIG.AU;
};

// Format date according to client's locale
export const formatDate = (date, clientLocale = null) => {
  if (!date) return '';

  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) return '';

  if (clientLocale) {
    const config = getLocalizationConfig(clientLocale.country);
    return dateObj.toLocaleDateString(config.locale);
  }

  // Default to Australian format
  return dateObj.toLocaleDateString('en-AU');
};

// Format currency according to client's locale
export const formatCurrency = (amount, clientLocale = null) => {
  if (!amount && amount !== 0) return '';

  if (clientLocale) {
    const config = getLocalizationConfig(clientLocale.country);
    const formatter = new Intl.NumberFormat(config.locale, {
      style: 'currency',
      currency: config.currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatter.format(amount);
  }

  // Default to Australian format
  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(amount);
};

// Format employment dates (MM/YYYY format)
export const formatEmploymentDate = (month, year, clientLocale = null) => {
  if (!month || !year) return '';

  if (clientLocale) {
    const config = getLocalizationConfig(clientLocale.country);
    if (config.dateFormat.startsWith('mm/')) {
      return `${String(month).padStart(2, '0')}/${year}`;
    } else {
      return `${String(month).padStart(2, '0')}/${year}`;
    }
  }

  // Default format MM/YYYY
  return `${String(month).padStart(2, '0')}/${year}`;
};

// Get available countries for selection
export const getAvailableCountries = () => {
  return Object.entries(LOCALIZATION_CONFIG).map(([code, config]) => ({
    code,
    name: config.countryName,
    config
  }));
};

// Format number according to client's locale
export const formatNumber = (number, clientLocale = null) => {
  if (!number && number !== 0) return '';

  if (clientLocale) {
    const config = getLocalizationConfig(clientLocale.country);
    return new Intl.NumberFormat(config.locale).format(number);
  }

  // Default to Australian format
  return new Intl.NumberFormat('en-AU').format(number);
};